namespace Solovis.RpcClients {

    /**
     * DataEnvProxyRpcClient can be used in environments where service expososes /Rpc/DataEnvProxy endpoints (same user permissions apply).
     */
    export class DataEnvProxyRpcClient implements Solovis.RpcClients.IRpcClient {

        private _dataEnvironmentId;

        constructor(options: {
            dataEnvironmentId: number;
        }) {
            this._dataEnvironmentId = options.dataEnvironmentId;
        }

        public invoke(
            url: string,
            requestMessage: any,
            callback?: (response: any, success?: boolean) => void
        ): Promise<any> {

            return Solovis.Rpc.invoke(
                "~/Rpc/DataEnvProxy/InvokeInDataEnvironment",
                {
                    dataEnvironmentId: this._dataEnvironmentId,
                    path: url,
                    request: requestMessage
                },
                callback);
        }

        /**
         * Invoke POST-RPC method asynchronously on server and show waiting dialog while doing so. 
         * @param url
         * @param requestMessage
         * @param callback
         * @param suppressDefaultErrorMessage
         */
        public invokeAndWait(
            url: string,
            requestMessage: any,
            callback?: (response: any, success?: boolean) => void,
            suppressDefaultErrorMessage?: boolean
        ): Promise<any> {

            return Solovis.Rpc.invokeAndWait(
                "~/Rpc/DataEnvProxy/InvokeInDataEnvironment",
                {
                    dataEnvironmentId: this._dataEnvironmentId,
                    path: url,
                    request: requestMessage
                },
                callback,
                suppressDefaultErrorMessage);
        }    

    }

}